import React, { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, Resolver, Controller } from "react-hook-form"
import API from '../API'
import { AdminAddPersonToProjectFunction, AdminDeleteEntryType, AdminReloadFunction, AdminUpdateEntryType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, AdminPersonMonthReport, AdminPersonsResponse, AdminProjectPersonsResponse, AdminProjectManagerResponse } from '../../../backend/src/api/dto';
import DatePicker from 'react-datepicker';

type FormValues = {
    startDate: string
    endDate: string
    personId: number | string
}




function AdminAddManagerToProject({  reload, alreadyAdded, addFunction }: {
    reload: AdminReloadFunction,
    alreadyAdded: AdminProjectManagerResponse[],
    addFunction: AdminAddPersonToProjectFunction,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            // startDate: '',
            // endDate: ''
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminPersonsResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)


    useEffect(() => {
        API.getPersons({divisionMatch: 'true'}).then(data => {
            setData(data)
        })
    }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        const form = getValues();


        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                //  console.log({ data: getValues() })


                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data.personId, data.startDate, data.endDate).then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })



                setSending(false)
            })()
        })

    }





    return (



        <Modal
            buttons={modalButtons}
            title={'Pridať osobu k projektu'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>

                <div className="row mb-2">
                    <div className="col-4 text-end mt-2">
                        Osoba
                    </div>
                    <div className="col-8">
                        <select className="form-select" {...register("personId")} >
                            <option value="">[ Vybrať ]</option>
                            {
                                data?.persons.filter(person => {
                                    return alreadyAdded.findIndex(item => item.personId === person.personId) === -1

                                }).map(person => {
                                    return (
                                        <option value={person.personId}>{person.name} {person.surname}</option>
                                    )
                                })
                            }
                        </select>

                    </div>
                </div>

            </form>
        </Modal>


    )

}

export default AdminAddManagerToProject
